import { KYMW6000Component } from './kymw6000.component';
import { FeatureListInfo } from './vo/feature_list_info.model';

/**
 * EC使用画像一覧表画面の値を管理するクラス
 *
 * @export KYMW6000Model
 * @class KYMW6000Model
 */
export class KYMW6000Model {

  KYMW6000Component: KYMW6000Component;

  /** 受注コード */
  public orderCode: string = <string>'';
  /** 媒体 */
  public mediumType: string = <string>'';
  /** 媒体名称 */
  public mediumName: string = <string>'';
  /** 媒体リスト */
  public mediumList: Array<any> = new Array<any>();
  /** 配達企画回（翌週 */
  public catalogId: string = <string>'';  
  /** 部門 */
  public classCode: string = <string>'';
  /** Ｐコード */
  public pCode: string = <string>'';
  /** 特集 */
  public featureCode: string = <string>'';
  /** マルチ・クロス */
  public multiOrCrossFlg: string = <string>'';
  /** 画像未指定 */
  public imageNoUseFlg: string = <string>'';
  /** 未確認 */
  public imageCheckFlg: string = <string>'';

  /** 特集一覧 */
  public FeatureList: FeatureListInfo[] = [];

}
